import { useEffect } from 'react';
import { useFormikContext } from 'formik';

export default function FormDirtyTracker({ onDirtyChange }: { onDirtyChange: (dirty: boolean) => void }) {
  const { dirty } = useFormikContext();
  useEffect(() => { onDirtyChange(dirty); }, [dirty, onDirtyChange]);
  return null;
}
